// USE POSTHOG ONLY CLIENTSIDE
const isOnramp = false

const commonRpPosthogEvents = {
    kycScreen: 'rp_kyc_screen',
    kycLevelButtonInteraction: 'rp_kyc_level_button_interaction',
    kycDataSubmitted: 'rp_kyc_data_submitted',
    kycDataNotify: 'rp_kyc_data_notify',
    kycError: 'rp_kyc_error',
    registrationCountrySubmit: 'rp_registration_country_submit',
    registrationReferralCode: 'rp_registration_referral_code',
    registrationInception: 'rp_registration_inception',
    registrationStart: 'rp_registration_start',
    registrationStartLogin: 'rp_registration_start_login',
    registrationVerifyEmail: 'rp_registration_verify_email',
    registrationEmailResend: 'rp_registration_email_resend',
    registrationWalletIdSuccess: 'rp_registration_wallet_id_success',
    registrationError: 'rp_registration_error',
    registrationNetworkError: 'rp_registration_network_error',
    registrationSocial: 'rp_registration_social',
    loginStart: 'rp_login_start',
    loginContinue: 'rp_login_continue',
    loginSwitchRegistration: 'rp_login_switch_registration',
    loginEnterTwoFa: 'rp_login_enter_2fa',
    loginEnterTwoFaHelp: 'rp_login_enter_2fa_help',
    loginNetworkError: 'rp_login_network_error',
    loginError: 'rp_login_error',
    loginSocial: 'rp_login_social',
    socialGo: 'rp_social_go',
    verifyEmailDenied: 'rp_verify_email_denied',
    twoFaSetupInstall: 'rp_2fa_setup_install',
    twoFaSetupScanQr: 'rp_2fa_setup_scan_qr',
    twoFaSetupValidation: 'rp_2fa_setup_validation',
    twoFaSetupBackup: 'rp_2fa_setup_backup',
    twoFaAddMethod: 'rp_2fa_add_method',
    buyPreviewOrder: 'rp_buy_preview_order',
    buyCardDetailsScreen: 'rp_buy_card_details_screen',
    buyCardDetailsPay: 'rp_buy_card_details_pay',
    buyOrderStatus: 'rp_buy_order_status',
    buyPreviewOrderPay: 'rp_buy_preview_order_pay',
    cardDeleteConfirm: 'rp_card_delete_confirm',
    buyCvvConfirm: 'rp_buy_cvv_confirm',
    buyCompleted: 'rp_buy_completed',
} as const

const commonOnrampPosthogEvents = {
    kycScreen: 'rp_ramp_kyc_screen',
    kycLevelButtonInteraction: 'rp_ramp_kyc_level_button_interaction',
    kycDataSubmitted: 'rp_ramp_kyc_data_submitted',
    kycDataNotify: 'rp_ramp_kyc_data_notify',
    kycError: 'rp_ramp_kyc_error',
    registrationCountrySubmit: 'rp_ramp_registration_country_submit',
    registrationReferralCode: 'rp_ramp_registration_referral_code',
    registrationInception: 'rp_ramp_registration_inception',
    registrationStart: 'rp_ramp_registration_start',
    registrationStartLogin: 'rp_ramp_registration_start_login',
    registrationVerifyEmail: 'rp_ramp_registration_verify_email',
    registrationEmailResend: 'rp_ramp_registration_email_resend',
    registrationWalletIdSuccess: 'rp_ramp_registration_wallet_id_success',
    registrationError: 'rp_ramp_registration_error',
    registrationNetworkError: 'rp_ramp_registration_network_error',
    registrationSocial: 'rp_ramp_registration_social',
    loginStart: 'rp_ramp_login_start',
    loginContinue: 'rp_ramp_login_continue',
    loginSwitchRegistration: 'rp_ramp_login_switch_registration',
    loginEnterTwoFa: 'rp_ramp_login_enter_2fa',
    loginEnterTwoFaHelp: 'rp_ramp_login_enter_2fa_help',
    loginNetworkError: 'rp_ramp_login_network_error',
    loginError: 'rp_ramp_login_error',
    loginSocial: 'rp_ramp_login_social',
    socialGo: 'rp_ramp_social_go',
    verifyEmailDenied: 'rp_ramp_verify_email_denied',
    twoFaSetupInstall: 'rp_ramp_2fa_setup_install',
    twoFaSetupScanQr: 'rp_ramp_2fa_setup_scan_qr',
    twoFaSetupValidation: 'rp_ramp_2fa_setup_validation',
    twoFaSetupBackup: 'rp_ramp_2fa_setup_backup',
    twoFaAddMethod: 'rp_ramp_2fa_add_method',
    buyPreviewOrder: 'rp_ramp_buy_preview_order',
    buyCardDetailsScreen: 'rp_ramp_buy_card_details_screen',
    buyCardDetailsPay: 'rp_ramp_buy_card_details_pay',
    buyOrderStatus: 'rp_ramp_buy_order_status',
    buyPreviewOrderPay: 'rp_ramp_buy_preview_order_pay',
    cardDeleteConfirm: 'rp_ramp_card_delete_confirm',
    buyCvvConfirm: 'rp_ramp_buy_cvv_confirm',
    buyCompleted: 'rp_ramp_buy_completed',
} as const

export const onrampPosthogEvents = {
    buyResult: 'rp_ramp_buy_result',
} as const

export const rpPosthogEvents = {
    onMainScreen: 'rp_main_screen',
    registrationFromMain: 'rp_registration_from_main',
    registrationLoginFromMain: 'rp_registration_login_from_main',
    registrationWalletIdClaim: 'rp_registration_wallet_id_claim',
    buyFlowDataFilled: 'rp_buy_flow_data_filled',
    buyUnexpectedError: 'rp_buy_unexpected_error',
    buyFlowProvideInfoModal: 'rp_buy_flow_provide_info_modal',
    buyFlowProvideInfoModalAction: 'rp_buy_flow_provide_info_modal_action',
    buyCurrencyVerify: 'rp_buy_currency_verify',
    buyCurrencyContactSupport: 'rp_buy_currency_contact_support',
    buySubmitAction: 'rp_buy_submit_order',
    currencyChooserFrom: 'rp_currency_chooser_from',
    currencyChooserTo: 'rp_currency_chooser_to',
    receiveCryptoFilled: 'rp_receive_crypto_filled',
    receiveCryptoCoinSelected: 'rp_receive_crypto_currency_select',
    receiveNetworkSelected: 'rp_receive_crypto_network_select',
    receiveAddressCopy: 'rp_receive_address_copy',
    receiveAddressGenerate: 'rp_receive_address_generate',
    receiveCryptoTypeSelected: 'rp_receive_crypto_info',
    receiveCryptoSelectAddress: 'rp_receive_manage_addresses', // TODO not used now, blocked by TA-1899
    receiveFiatCurrencySelected: 'rp_receive_fiat_filled',
    receiveFiatTypeSelected: 'rp_receive_fiat_info',
    sendCryptoOpen: 'rp_send_crypto_open',
    sendCryptoInsert: 'rp_send_crypto_address_insert',
    sendCryptoCoinSelect: 'rp_send_crypto_currency_insert',
    sendCryptoNetworkSelect: 'rp_send_crypto_network_insert',
    sendCryptoAmountInsert: 'rp_send_crypto_amount_insert',
    sendCryptoClickMax: 'rp_send_crypto_max_amount',
    sendCryptoFeeToggle: 'rp_send_crypto_fee_toogle',
    sendCryptoContinue: 'rp_send_crypto_continue',
    sendCryptoConfirmShow: 'rp_send_crypto_confirm',
    sendCryptoConfirmSend: 'rp_send_crypto_confirm_send',
    sendCryptoResendEmail: 'rp_send_crypto_email_resend_code',
    sendCryptoContactSupport: 'rp_send_crypto_contact_support',
    sendCrypto2FAInsert: 'rp_send_crypto_2fa_code',
    sendCryptoCodesContinue: 'rp_send_crypto_codes',
    sendCryptoShowStatusScreen: 'rp_send_crypto_status',
    sendCryptoStatusPending: 'rp_send_crypto_status_pending',
    sendCryptoStatusSuccess: 'rp_send_crypto_status_success',
    sendCryptoStatusFailed: 'rp_send_crypto_status_failed.',
    sendCryptoSendMore: 'rp_send_successful_more',
    swapScreen: 'rp_swap_screen',
    swapCryptoSelectOpen: 'rp_swap_crypto_select_open',
    swapSwitchCoins: 'rp_swap_switch_coins',
    swapErrorMessage: 'rp_swap_error_message',
    swapFlowAvailable: 'rp_swap_flow_available',
    swapConfirm: 'rp_swap_confirm',
    swapFlowStatusPending: 'rp_swap_flow_status_pending',
    swapFlowStatusSuccess: 'rp_swap_flow_status_success',
    swapFlowStatusFailed: 'rp_swap_flow_status_failed',
    swapDataFilled: 'rp_swap_flow_data_filled',
    swapButtonInteraction: 'rp_swap_flow_swap_button_interaction',
    swapStatus: 'rp_swap_flow_status',
    swapError: 'rp_swap_error',
    dashboardOnboardingOpen: 'rp_dash_open',
    dashboardOnboardingVerify: 'rp_dash_verify_now',
    dashboardOnboardingVerifyInProgress: 'rp_dash_verify_in_progress',
    dashboardOnboardingUploadDocuments: 'rp_dash_verify_issue_upload',
    dashboardOnboardingFailedContactSupport: 'rp_dash_verify_failed_support',
    dashboardOnboardingBuy: 'rp_dash_buy',
    dashboardOnboardingReceive: 'rp_dash_receive',
    dashboardOnboardingError: 'rp_dash_error',
    dashboardOnboardingVerifyUpdated: 'rp_dash_verify_updated',
} as const

export enum PosthogWalletAddressType {
    address = 'Address',
    walletId = 'Wallet id',
    email = 'Email',
    clientId = 'Client id',
}
export enum PosthogReceiveCryptoType {
    address = 'Address',
    walletId = 'Wallet Id',
    emailOrClientId = 'Email or Client ID',
}

export enum PosthogSendCryptoType {
    onchain = 'onchain',
    offchain = 'offchain',
    ens = 'ens',
    walletId = 'wallet id',
    clientId = 'client id',
    email = 'email',
}

// Use this for onramp/app events (buy flow, signin/signup flow, etc)
export const commonPosthogEvents = isOnramp ? commonOnrampPosthogEvents : commonRpPosthogEvents

export type PosthogEventCode =
    | (typeof commonPosthogEvents)[keyof typeof commonPosthogEvents]
    | (typeof onrampPosthogEvents)[keyof typeof onrampPosthogEvents]
    | (typeof rpPosthogEvents)[keyof typeof rpPosthogEvents]

export const screenSources = {
    signUp: 'signUp',
    migration: 'migration',
    swap: 'swap',
    send: 'send',
    receive: 'receive',
    settings: 'settings',
    buy_crypto: 'buy_crypto',
} as const

export type ScreenSources = keyof typeof screenSources

export type PosthogEventData = Record<string, string | number | boolean | undefined | null>
